import DashboardHeader from "../components/DashboardHeader";
import { Row, Col, Form, Toast, ToastContainer } from "react-bootstrap";
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import { 
  User, 
  Bell, 
  Shield, 
  Palette, 
  Mail, 
  Smartphone, 
  Globe, 
  Save, 
  X,
  CheckCircle,
  Gift,
  Copy,
  CreditCard,
  Calendar,
  Settings
} from "lucide-react";

import arhitectImg from "../assets/arhitect.png";
import ambasadorImg from "../assets/ambasador.png";
import maestruImg from "../assets/maestru.png";
import vizionarImg from "../assets/vizionar.png";
import membruImg from "../assets/membru.png";

export default function SettingsPage() {
  const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [userIdSupabase, setUserIdSupabase] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function getUserId() {
      const { data: { session } } = await supabase.auth.getSession();
      setUserIdSupabase(session?.user?.id ?? null);
    }
    getUserId();
  }, []);

  useEffect(() => {
    if (!userIdSupabase) return;
    async function loadMember() {
      try {
        setLoading(true);
        const res = await fetch(
          `https://prdp-api.suport-949.workers.dev/api/membru-meu?user_id_supabase=${userIdSupabase}`,
          {
            headers: {
              Authorization: "Bearer unwantedtok",
            },
          }
        );
        if (!res.ok) throw new Error("Nu s-au putut prelua datele.");
        const data = await res.json();
        setMemberData(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    loadMember();
  }, [userIdSupabase]);

  const handleChange = (field) => (e) => {
    setMemberData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSave = async () => {
    if (!memberData) return;
    setSaving(true);
    setError(null);
    try {
      const res = await fetch(
        `https://prdp-api.suport-949.workers.dev/api/membri/${memberData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer unwantedtok",
          },
          body: JSON.stringify(memberData),
        }
      );
      if (!res.ok) throw new Error("Nu s-a putut salva modificarea.");
      setToastMessage("Datele au fost salvate cu succes!");
      setShowToast(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const copyToClipboard = () => {
    if (memberData?.cod_recomandare) {
      navigator.clipboard.writeText(memberData.cod_recomandare);
      setCopied(true);
      setToastMessage("Codul a fost copiat în clipboard!");
      setShowToast(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const getCardImage = (pachet) => {
    const p = pachet ? pachet.toLowerCase() : "membru";
    switch (p) {
      case "arhitect": return arhitectImg;
      case "ambasador": return ambasadorImg;
      case "maestru": return maestruImg;
      case "vizionar": return vizionarImg;
      default: return membruImg;
    }
  };

  const getExpirationDate = (tipCotizatie) => {
    const now = new Date();
    let expDate;
    if (tipCotizatie === "anual") {
      expDate = new Date(now.getFullYear(), 11, 31);
    } else {
      expDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    }
    return expDate.toLocaleDateString("ro-RO", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  if (loading) {
    return <div style={{ backgroundColor: "#0b1120", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", color: "#94a3b8" }}>Se încarcă datele profilului...</div>;
  }

  if (error) {
    return <div style={{ backgroundColor: "#0b1120", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", color: "#ef4444" }}>Eroare: {error}</div>;
  }

  if (!memberData) {
    return <div style={{ backgroundColor: "#0b1120", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", color: "#94a3b8" }}>Profil membru inexistent.</div>;
  }

  const sectionIcon = (IconComponent) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 48,
        height: 48,
        borderRadius: "14px",
        background: "rgba(251, 191, 36, 0.1)",
        color: "#fbbf24",
        marginRight: 16,
      }}
    >
      <IconComponent size={24} />
    </span>
  );

  const secOptStyle = {
    background: "#0f172a",
    borderRadius: "16px",
    padding: "16px 20px",
    marginBottom: "12px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    fontSize: "1rem",
    color: "#e2e8f0",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    gap: 16,
    cursor: "pointer",
    outline: "none",
    transition: "all 0.2s ease",
    width: "100%",
    textAlign: "left"
  };

  const labelStyle = { color: "#cbd5e1", fontSize: "0.8rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px", marginBottom: "8px", display: "block" };
  const inputStyle = {
    backgroundColor: "#0f172a", border: "1px solid rgba(255, 255, 255, 0.1)", color: "#f8fafc", borderRadius: "12px", padding: "12px 16px", width: "100%", outline: "none", transition: "all 0.2s ease", fontSize: "1rem"
  };

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "60px" }}>
      <DashboardHeader user={{ prenume: memberData.prenume, nume: memberData.nume }} />
      
      <style>{`
        .premium-input:focus {
          border-color: #fbbf24 !important;
          box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.2) !important;
        }
        .premium-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        select.premium-input {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
          background-size: 16px;
          padding-right: 48px !important;
        }

        .premium-card {
          background: linear-gradient(145deg, #1e293b 0%, #0f172a 100%);
          border-radius: 24px;
          padding: 32px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
          height: 100%;
        }
        .sec-btn:hover:not(:disabled) {
          background-color: rgba(255, 255, 255, 0.05) !important;
          border-color: rgba(255, 255, 255, 0.1) !important;
          transform: translateY(-2px);
        }

        .form-switch {
          padding-left: 0 !important;
          display: flex;
          align-items: center;
          margin-bottom: 4px;
        }
        .form-switch .form-check-input {
          margin-left: 0 !important;
          margin-top: 0 !important;
          margin-right: 14px !important;
          width: 2.8em !important;
          height: 1.4em !important;
          background-color: #334155 !important;
          border-color: #475569 !important;
          cursor: pointer;
        }
        .form-switch .form-check-input:checked {
          background-color: #fbbf24 !important;
          border-color: #fbbf24 !important;
        }
        .form-check-label {
          display: flex;
          align-items: center;
          margin-top: 2px;
        }
        
        .text-muted-premium {
          color: #64748b !important;
          font-size: 0.85rem;
          margin-bottom: 24px;
          margin-left: 58px;
          display: block;
        }

        .custom-toast {
          background-color: rgba(16, 185, 129, 0.95) !important;
          color: white !important;
          border: none !important;
          border-radius: 16px !important;
          backdrop-filter: blur(10px);
        }
        
        .promo-card {
          border-color: rgba(251, 191, 36, 0.2);
        }

        .card-img-hover {
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), filter 0.4s ease;
          filter: drop-shadow(0 15px 25px rgba(0,0,0,0.5));
        }
        .card-img-hover:hover {
          transform: translateY(-8px) scale(1.02);
          filter: drop-shadow(0 20px 35px rgba(245, 158, 11, 0.2));
        }
      `}</style>

      <div className="container mt-5">
        <Row className="g-4 mb-4">
          <Col lg={7}>
            <div className="premium-card">
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(User)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.5rem" }}>Informații Profil</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.95rem" }}>
                    Actualizează informațiile personale și de contact
                  </p>
                </div>
              </div>

              <Form>
                <Row className="g-3 mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <label style={labelStyle}>Prenume</label>
                      <input type="text" className="premium-input" style={inputStyle} value={memberData.prenume || ""} onChange={handleChange("prenume")} />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <label style={labelStyle}>Nume</label>
                      <input type="text" className="premium-input" style={inputStyle} value={memberData.nume || ""} onChange={handleChange("nume")} />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <label style={labelStyle}>Email</label>
                  <input type="email" className="premium-input" style={inputStyle} value={memberData.email || ""} disabled />
                </Form.Group>

                <Form.Group className="mb-3">
                  <label style={labelStyle}>Telefon</label>
                  <input type="text" className="premium-input" style={inputStyle} value={memberData.telefon || ""} onChange={handleChange("telefon")} />
                </Form.Group>

                <Form.Group className="mb-3">
                  <label style={labelStyle}>Adresă</label>
                  <input type="text" className="premium-input" style={inputStyle} value={memberData.adresa || ""} onChange={handleChange("adresa")} />
                </Form.Group>

                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Group>
                      <label style={labelStyle}>CNP</label>
                      <input type="text" className="premium-input" style={inputStyle} value={memberData.cnp || ""} onChange={handleChange("cnp")} />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <label style={labelStyle}>Serie și număr buletin</label>
                      <input type="text" className="premium-input" style={inputStyle} value={memberData.serie_numar_ci || ""} onChange={handleChange("serie_numar_ci")} />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-3 mt-2">
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    style={{
                      backgroundColor: "#fbbf24", color: "#0f172a", border: "none", borderRadius: "12px", padding: "12px 28px", fontWeight: 700, fontSize: "1rem", display: "flex", alignItems: "center", gap: "8px", cursor: saving ? "not-allowed" : "pointer", transition: "all 0.2s ease", opacity: saving ? 0.7 : 1
                    }}
                    onMouseEnter={(e) => { if (!saving) e.currentTarget.style.backgroundColor = "#f59e0b"; }}
                    onMouseLeave={(e) => { if (!saving) e.currentTarget.style.backgroundColor = "#fbbf24"; }}
                    type="button"
                  >
                    <Save size={18} /> {saving ? "Se salvează..." : "Salvează"}
                  </button>
                  <button 
                    onClick={() => window.location.reload()}
                    style={{
                      backgroundColor: "transparent", color: "#cbd5e1", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "12px 28px", fontWeight: 600, fontSize: "1rem", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", transition: "all 0.2s ease"
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                    type="button"
                  >
                    <X size={18} /> Anulează
                  </button>
                </div>
              </Form>
            </div>
          </Col>

          <Col lg={5} className="d-flex flex-column gap-4">
            
            {/* ZONA NOUĂ: COTIZAȚIA TA */}
            <div className="premium-card" style={{ padding: "28px" }}>
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(CreditCard)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.35rem" }}>Cotizația ta</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.85rem" }}>
                    Pachetul curent și valabilitatea
                  </p>
                </div>
              </div>

              <div className="d-flex flex-column align-items-center mb-4 pt-2">
                <img 
                  src={getCardImage(memberData.pachet_cotizatie)} 
                  alt="Legitimație PRDP" 
                  className="card-img-hover"
                  style={{ width: "90%", maxWidth: "300px", objectFit: "contain", marginBottom: "20px" }} 
                />
                
                <h4 style={{ color: "#fbbf24", fontWeight: 800, fontSize: "1.6rem", letterSpacing: "-0.5px", marginBottom: "4px" }}>
                  Pachet {memberData.pachet_cotizatie || "Membru"}
                </h4>
                
                <p style={{ color: "#94a3b8", fontSize: "1rem", marginBottom: "16px" }}>
                  Plată <strong style={{ color: "#fff", textTransform: "capitalize" }}>{memberData.tip_cotizatie || "lunar"}</strong>
                </p>

                <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.05)", borderRadius: "12px", padding: "12px 20px", display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "center" }}>
                  <Calendar size={18} color="#cbd5e1" />
                  <span style={{ color: "#e2e8f0", fontSize: "0.95rem", fontWeight: 600 }}>
                    Expiră la {getExpirationDate(memberData.tip_cotizatie)}
                  </span>
                </div>
              </div>

              <button 
                disabled 
                style={{ width: "100%", background: "rgba(255,255,255,0.02)", color: "#64748b", border: "1px dashed rgba(255,255,255,0.1)", borderRadius: "14px", padding: "14px", fontWeight: 600, cursor: "not-allowed", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", fontSize: "0.95rem" }}
              >
                <Settings size={18} /> Modifică pachetul (În curând)
              </button>
            </div>

            <div className="premium-card promo-card" style={{ padding: "28px" }}>
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(Gift)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.35rem" }}>Invită & Câștigă</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.85rem" }}>
                    Codul tău de recomandare
                  </p>
                </div>
              </div>
              
              <div style={{ 
                background: "rgba(0,0,0,0.2)", 
                borderRadius: "12px", 
                padding: "16px 20px", 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                border: "1px dashed rgba(251, 191, 36, 0.4)" 
              }}>
                <span style={{ 
                  fontSize: "1.4rem", 
                  fontWeight: 900, 
                  color: "#fbbf24", 
                  letterSpacing: "3px",
                  fontFamily: "monospace"
                }}>
                  {memberData.cod_recomandare || "INDISPONIBIL"}
                </span>
                
                <button
                  onClick={copyToClipboard}
                  disabled={!memberData.cod_recomandare}
                  style={{ 
                    background: copied ? "rgba(16, 185, 129, 0.2)" : "rgba(251, 191, 36, 0.1)", 
                    color: copied ? "#10b981" : "#fbbf24", 
                    border: "none", 
                    padding: "8px 16px", 
                    borderRadius: "8px", 
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.2s"
                  }}
                >
                  {copied ? <CheckCircle size={16} /> : <Copy size={16} />}
                  {copied ? "Copiat" : "Copiază"}
                </button>
              </div>
              
              <p style={{ fontSize: "0.85rem", color: "#94a3b8", marginTop: "16px", marginBottom: 0, lineHeight: 1.5 }}>
                Oferă acest cod prietenilor la completarea formularului de înscriere. 
                Vei primi <strong>200 de puncte</strong> pentru fiecare membru aprobat în partid!
              </p>
            </div>

            <div className="premium-card" style={{ padding: "28px" }}>
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(Bell)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.35rem" }}>Notificări</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.85rem" }}>
                    Configurați preferințele de comunicare
                  </p>
                </div>
              </div>
              
              <Form>
                <Form.Check
                  type="switch" id="notificari-email"
                  label={<><Mail size={16} className="me-2" style={{color: "#cbd5e1"}}/> <span style={{color: "#e2e8f0", fontWeight: 500}}>Notificări email</span></>}
                  defaultChecked
                />
                <span className="text-muted-premium">Primiți actualizări prin email</span>
                
                <Form.Check
                  type="switch" id="notificari-push"
                  label={<><Smartphone size={16} className="me-2" style={{color: "#cbd5e1"}}/> <span style={{color: "#e2e8f0", fontWeight: 500}}>Notificări push</span></>}
                />
                <span className="text-muted-premium">Notificări instant pe dispozitiv</span>
                
                <Form.Check
                  type="switch" id="notificari-saptamanal"
                  label={<><Globe size={16} className="me-2" style={{color: "#cbd5e1"}}/> <span style={{color: "#e2e8f0", fontWeight: 500}}>Raport lunar</span></>}
                  defaultChecked
                />
                <span className="text-muted-premium mb-0">Sumar al activităților PRDP</span>
              </Form>
            </div>

            <div className="premium-card" style={{ padding: "28px" }}>
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(Shield)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.35rem" }}>Securitate</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.85rem" }}>
                    Gestionați parola și contul
                  </p>
                </div>
              </div>
              <div className="settings-list">
                <button className="sec-btn" style={secOptStyle} onClick={() => navigate("/schimbare-parola")}>
                  <Shield size={20} color="#fbbf24" /> Schimbă parola
                </button>
                <button className="sec-btn" style={{ ...secOptStyle, opacity: 0.6, cursor: "not-allowed" }} disabled>
                  <Smartphone size={20} color="#94a3b8" /> Autentificare în doi pași
                </button>
                <button className="sec-btn" style={{ ...secOptStyle, opacity: 0.6, cursor: "not-allowed", marginBottom: 0 }} disabled>
                  <Globe size={20} color="#94a3b8" /> Sesiuni active
                </button>
              </div>
            </div>

            <div className="premium-card" style={{ padding: "28px" }}>
              <div className="mb-4 d-flex align-items-center">
                {sectionIcon(Palette)}
                <div>
                  <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.35rem" }}>Preferințe</h3>
                  <p style={{ color: "#94a3b8", marginBottom: 0, fontSize: "0.85rem" }}>
                    Personalizați interfața
                  </p>
                </div>
              </div>
              <Form>
                <Form.Group className="mb-3">
                  <label style={labelStyle}>Limba</label>
                  <select className="premium-input" style={{...inputStyle, opacity: 0.7, cursor: "not-allowed"}} disabled>
                    <option>Română</option>
                  </select>
                </Form.Group>
                <Form.Group>
                  <label style={labelStyle}>Temă</label>
                  <select className="premium-input" style={{...inputStyle, opacity: 0.7, cursor: "not-allowed"}} disabled>
                    <option>Dark Mode (Activ)</option>
                  </select>
                </Form.Group>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <ToastContainer position="top-end" className="p-4" style={{ zIndex: 9999 }}>
        <Toast className="custom-toast" onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
          <Toast.Body className="d-flex align-items-center gap-2" style={{ fontSize: "1rem", fontWeight: 500, padding: "16px" }}>
            <CheckCircle size={22} /> {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
